import { createAction, props } from '@ngrx/store';

export const submittalPackageSidebarActions = {
  createPackageOpened: createAction(
    '[Add/Edit Submittal Package Sidebar Component] Create Package Opened',
  ),
  submittalRegistryListInitialized: createAction(
    '[Add/Edit Submittal Package Sidebar Component] Initialize Submittal Registry List',
    props<{ projectId: number }>(),
  ),
  submittalRegistryListEndReached: createAction(
    '[Add/Edit Submittal Package Sidebar Component] Submittal Registry List End Reached',
    props<{ projectId: number }>(),
  ),
  editPackageOpened: createAction(
    '[Add/Edit Submittal Package Sidebar Component] Edit Package Opened',
    props<{ packageId: number }>(),
  ),
};
